import type { API_STATUS } from 'constants/enums';

interface IndividualPnlDetails {
  exit_price: string;
  pnl: string;
}
interface IndividualPnl {
  [key: number]: IndividualPnlDetails;
}
interface PNLData {
  pnl: string;
  spot_price: string;
  individual_pnls: IndividualPnl;
}

interface BasketAnalytics {
  break_even_point: string[];
  result_pnls: PNLData[];
  expiry_pnls: PNLData[];
  max_loss: string;
  max_profit: string;
}

interface BasketAnalyzeState {
  pnlTab: {
    selectedTargetPrice: number;
    selectedTargetDate: number;
    selectedTargetDateIndex: number;
    selectedRows: number[];
    lastResolvedTargetPrice: number;
  };
  basketAnalytics: {
    data: null | BasketAnalytics;
    apiStatus: API_STATUS;
    errorMessage: null | string;
    isAnalyticsApiRefetching: boolean;
  };
  isBasketAnalyzeLoading: boolean;
}

interface Position {
  product_id: number;
  entry_price: number;
  size: number;
}

interface BasketAnalyticsRequestPayload {
  underlying_index_symbol: string;
  target_date: number;
  target_price: number;
  positions: Position[];
}

enum NumberSign {
  DEFAULT = 'default',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export type { BasketAnalyzeState, BasketAnalyticsRequestPayload, Position, PNLData };
export { NumberSign };
